(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/frejaeid-errorhandling.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/frejaeid-errorhandling.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.behaviors.FrejaEidErrorHandling = Marionette.Behavior.extend({
    onFrejaEidError: function onFrejaEidError(xhr) {
      var _this = this;

      var logger = svs.core.log.getLogger('module:player-login');
      var errorCode, errorMessage;
      var newCustomerEvent = {
        category: 'Users',
        action: 'Customer Registration'
      };

      var errorFunction = function errorFunction() {
        svs.utils.url.navigate(_this.view.model.get('returnUrl') || svs.utils.urlMapping.get('startPage'));
      };

      if (svs.utils.ns.isNamespace('responseJSON.error.code', xhr || {})) {
        errorCode = xhr.responseJSON.error.code;
      }

      switch (errorCode) {
        case 1:
          errorMessage = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
          break;

        case 16:
          {
            var custRegQS = "returnUrl=".concat(encodeURIComponent(this.view.model.get('returnUrl')), "&rnc=").concat(this.view.model.get('returnNewCustomer'));
            newCustomerEvent.opt_label = 'started_new_customer_from_frejaeid';
            svs.components.analytics.trackEvent(newCustomerEvent, function () {
              var custRegDialogTitle = 'BankID krävs',
                  custRegDialogMessage = 'För att bli kund på AB Svenska Spel så måste BankID användas',
                  custRegDialogCallback = function custRegDialogCallback() {
                svs.utils.url.navigate("".concat(svs.utils.urlMapping.get('customerRegistrationHome'), "?").concat(custRegQS));
              };

              var dialog = new svs.components.dialog.Confirm({
                type: svs.components.dialog.type.ERROR,
                title: custRegDialogTitle,
                message: [{
                  type: svs.components.dialog.message.TEXT,
                  text: custRegDialogMessage
                }],
                actions: [{
                  title: 'OK',
                  callback: custRegDialogCallback
                }]
              });
              svs.components.dialog.api.add(dialog);
            }, this);
            break;
          }

        case 22:
          errorMessage = 'Ups! Vår slagning mot Spelpaus.se för att se om du är spelpausad eller ej gav inget svar. Vänligen försök igen. Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
          break;

        default:
          logger.error('Unhandled login error', xhr);
          errorMessage = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
      }

      if (errorMessage) {
        var dialog = new svs.components.dialog.Confirm({
          type: svs.components.dialog.type.ERROR,
          title: 'Misslyckad inloggning',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: errorMessage
          }],
          actions: [{
            title: 'OK',
            callback: errorFunction
          }]
        });
        svs.components.dialog.api.add(dialog);
      }
    }
  });
})(Backbone, _, svs);
 })(window);